import { Caravan, Package } from "lucide-react";
import { cn } from "@/lib/utils";

interface CartTypeBadgeProps {
  hasVin: boolean;
  vin?: string;
  className?: string;
  showVin?: boolean;
}

/**
 * Shared cart type badge used in CartFlyout, /cart and /checkout.
 * - "Unit Specific Order" (primary) when a VIN is attached.
 * - "Stock Order" (primary faded 50%) otherwise.
 * No hover effect.
 */
export function CartTypeBadge({ hasVin, vin, className, showVin = false }: CartTypeBadgeProps) {
  const Icon = hasVin ? Caravan : Package;
  const label = hasVin ? "Unit Specific Order" : "Stock Order";

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold border border-transparent cursor-default select-none",
        hasVin
          ? "bg-primary text-primary-foreground"
          : "bg-primary/75 text-primary-foreground",
        className
      )}
    >
      <Icon className="h-3.5 w-3.5" />
      <span>{label}</span>
      {hasVin && showVin && vin ? (
        <span className="ml-1 font-normal opacity-90">· {vin}</span>
      ) : null}
    </span>
  );
}
